import { html } from 'fxjs/es';

export const myCharactersHelpModalBody = (is_mobile) => {
  return html`<div class="help_modal_wrapper">
    <div class="title">Notice</div>
    <img
      class="help_img"
      alt="my-characters-notice"
      src="${is_mobile
        ? '//s3.marpple.co/files/u_193535/2025/12/original/82eb5d3df8bdcb7ed8c8725bf8f2e2be761f62212.png'
        : '//s3.marpple.co/files/u_193535/2025/12/original/8a47e4aba583d7e95f263ffd1eb8e9f5eee262f61.png'}"
    />
  </div> `;
};

export const warningModalBody = ({ title, character_names, img_src, width, height }) => {
  return html`<div class="warning_modal_wrapper">
    <div class="content_container">
      <p class="content">${title}</p>
      <div class="description">
        ${character_names.map((name) => html`<p class="name_text">${name}</p>`).join('')}
      </div>
    </div>
    <img class="warning_image" alt="warning-image" src=${img_src} width="${width}" height="${height}" />
  </div>`;
};
